module.exports = __webpack_public_path__ + "static/media/bgPlayer.29b17544.gif";